import { useState, useEffect } from 'react';
import { getPublicSettings } from '../services/contentApi';
import './Banner.css';

export default function Banner() {
  const [banner, setBanner] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    getPublicSettings().then(s => {
      if (!s || s.banner_active !== '1' || !s.banner_text) return;
      // Vérifier si l'utilisateur a déjà fermé cette bannière
      const key = `tta_banner_dismissed_${btoa(s.banner_text).slice(0, 16)}`;
      if (localStorage.getItem(key)) return;
      setBanner({ text: s.banner_text, link: s.banner_link || '', type: s.banner_type || 'info', dismissKey: key });
      setVisible(true);
    });
  }, []);

  const dismiss = () => {
    if (banner?.dismissKey) localStorage.setItem(banner.dismissKey, '1');
    setVisible(false);
  };

  if (!visible || !banner) return null;

  return (
    <div className={`site-banner site-banner--${banner.type}`} role="alert">
      <span className="site-banner__text">
        {banner.text}
        {banner.link && (
          <a href={banner.link} className="site-banner__link" target={banner.link.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">
            &nbsp;En savoir plus →
          </a>
        )}
      </span>
      <button className="site-banner__close" onClick={dismiss} aria-label="Fermer">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  );
}
